export default "__VITE_ASSET__CQmJqBKU__"